import startcase from "lodash.startcase";

export const parseRole = (role: string) => {
    return (
        role === "qa" ? "QA" : startcase(role)
    );
};
